import { Injectable } from "@angular/core";
import { SwUpdate, VersionReadyEvent } from "@angular/service-worker";
import { filter, first, map } from "rxjs/operators";
import { DialogService, DialogType } from "./services/dialog.service";
import { ToastService } from "./toast.service";

@Injectable()
export class PromptUpdateService {
  constructor(
    private updates: SwUpdate,
    private toasterService: ToastService,
    private _dialogService: DialogService
  ) {
    updates.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === "VERSION_READY"),
        map((evt) => ({
          type: "UPDATE_AVAILABLE",
          current: evt.currentVersion,
          available: evt.latestVersion,
        }))
      )
      .subscribe((evt) => {
        if (evt.current !== evt.available) this.promptUser();
      });
  }

  promptUser(): boolean {
    this._dialogService
      .openDialog({
        headerText: $localize`:@@version.update.header:New version available!`,
        detailText: $localize`:@@version.update.message:There's a new version available. Please click the button below to load it. If you still have unsaved changes, you can also cancel, In that case, please save your changes and click on the version number to load the new version.`,
        dialogType: DialogType.Continue,
        fullscreen: true,
      })
      .pipe(first())
      .subscribe((feedback: boolean) => {
        if (feedback) {
          this.updateVersion();
        } else {
          sessionStorage.setItem("updateAvailable", "true");
          this.toasterService.showWarnToast(
            $localize`:@@version.update.detected.header:Older Version Detected!`,
            $localize`:@@version.update.detected.body:Press the version number when you're ready to update!`
          );
        }
      });
    return true;
  }

  updateVersion() {
    this.updates.activateUpdate().then((succesfullUpdate) => {
      if (succesfullUpdate) document.location.reload();
    });
  }
}

@Injectable()
export class PromptUpdateServiceMock {
  constructor() {}
}
